import React, { useEffect, useState } from 'react'
import { LinkButton } from '@zera-admin/button'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import Page, { PageHeader } from '@zera-admin/page'
import Table from '@zera-admin/table'

import Pager from 'components/pager'
import MainLayout from 'layouts/main'
import namedEntityRecognitionsService, {
  NamedEntityRecognition,
  NamedEntityRecognitionResponse,
} from 'services/http/dataset/named-entity-recognition'

import { NamedEntityRecognitionListProps } from './types'

const NamedEntityRecognitionList: React.FunctionComponent<
  NamedEntityRecognitionListProps
> = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [namedEntityRecognition, setNamedEntityRecognition] =
    useState<NamedEntityRecognitionResponse>()

  useEffect(() => {
    getNamedEntityRecognitions()
  }, [])

  const getNamedEntityRecognitions = async () => {
    try {
      const response = await namedEntityRecognitionsService.get()

      setNamedEntityRecognition(response.data)
      setIsLoading(false)
    } catch (err) {
      console.log(err)
    }
  }

  const renderPageHeader = () => {
    const actions = (
      <LinkButton appearance="primary" href="/named-entity-recognition/create">
        İsimlendirilmiş varlık tanıma oluştur
      </LinkButton>
    )

    const breadcrumbs = (
      <Breadcrumb>
        <BreadcrumbItem text="Anasayfa" href="/" />
        <BreadcrumbItem text="İsimlendirilmiş varlık tanıma" />
      </Breadcrumb>
    )

    const bottomBar = (
      <p>
        Tüm isimlendirilmiş varlık tanıma setlerini görüntüleyebilir, yeni
        oluşturabilir, varolanları düzenleyebilirsiniz.
      </p>
    )

    return (
      <PageHeader
        actions={actions}
        bottomBar={bottomBar}
        breadcrumbs={breadcrumbs}
      >
        İsimlendirilmiş varlık tanıma
      </PageHeader>
    )
  }

  const renderPageTable = () => {
    const columns = [
      {
        name: 'text',
        text: 'İsimlendirilmiş varlık tanıma seti metni',
      },
      {
        name: 'languageCode',
        text: 'Dil kodu',
      },
      {
        name: 'createdDate',
        text: 'Oluşturulma tarihi',
      },
      {
        name: 'operation',
        text: 'İşlemler ',
        width: '100px',
        render: (item: NamedEntityRecognition) => (
          <LinkButton
            appearance="subtle-link"
            href={`/named-entity-recognition/update/${item.id}`}
          >
            Görüntüle
          </LinkButton>
        ),
      },
    ]

    if (namedEntityRecognition) {
      return (
        <React.Fragment>
          <Table
            columns={columns as any}
            rows={namedEntityRecognition.list}
            isLoading={isLoading}
            helperMessage="Aradığınız kriterlere uygun bir veri bulunamadı"
          />
          <Pager pages={namedEntityRecognition.pageCount} />
        </React.Fragment>
      )
    }

    return null
  }

  return (
    <MainLayout>
      <Page>
        {renderPageHeader()}
        {renderPageTable()}
      </Page>
    </MainLayout>
  )
}

export default NamedEntityRecognitionList
